import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const spoonPractice: BlogMetaData = {
  title: 'スプーン練習はいつから？三本指を育てる始め方とこぼさないコツ',
  description:
    'スプーン練習はいつから始める?三本指を育てる環境づくりと持ち方の目安、こぼす・遊び食べへの対処法を、モンテッソーリ「日常生活の練習」の視点でやさしく解説します。',
  thumbnailUrl: '/img/blog-spoon-practice.webp',
  filePath: buildBlogFilePath('spoon-practice'),
  category: BLOG_CATEGORY.PLAY_TOOLS,
};
